import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path><path d="M27.105 8h-15.21C11.358 8 11 7.6 11 7s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1z"></path><path d="M27.105 17h-15.21c-.537 0-.895-.4-.895-1s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1z"></path><path d="M11.895 26h15.21c.448 0 .895-.4.895-1s-.358-1-.895-1h-15.21c-.537 0-.895.4-.895 1s.358 1 .895 1z"></path><path d="M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"></path><path d="M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path></g>';
export var ListBulletedOutlineSVG = function ListBulletedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ListBulletedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ListBulletedOutlineSVG);